/**
 * 字段默认值类型
 * @author wangjiegj<wangjiegj@inspur.com>
 */

/**
 * 字段默认值类型
 */
enum ElementDefaultVauleType {
    /**
     * 值类型
     */
    Value = 0,

    /**
     * 表达式类型
     */
    Expression = 1,
}

export { ElementDefaultVauleType };

